import { useEffect, useState } from 'react'

// Revisao final do ciclo 2A (02/10): o PWA volta do fundo SEM recarregar, e uma
// tela que so redesenha quando o banco muda ficava com o "agora" de quando abriu
// -- o Inicio aberto na quinta mostrava "Qui" e a agenda de quinta na sexta.
// Este relogio vivo avanca a cada minuto e ao voltar para o app.
export function useAgora(intervaloMs = 60_000): Date {
  const [agora, setAgora] = useState(() => new Date())
  useEffect(() => {
    const tique = () => setAgora(new Date())
    const id = setInterval(tique, intervaloMs)
    const aoVoltar = () => { if (document.visibilityState === 'visible') tique() }
    document.addEventListener('visibilitychange', aoVoltar)
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', aoVoltar) }
  }, [intervaloMs])
  return agora
}
